module.exports = __webpack_public_path__ + "media/images/icon_arrow_blue-3567afbf50316d3d7ae5695dc785ef45.png";